import React from "react";
import styles from "./plugin.module.scss";
import { ITitlePlugin } from "../../model/plugin";
import classNames from "classnames";
import Image from "next/legacy/image";
interface TitleAdProps {
  data: ITitlePlugin[];
}

export function Title(props: TitleAdProps) {
  const { data } = props;
  return (
    <div className={classNames(styles["title"], "justify-space-beetwen")}>
      {data?.map((title, index) =>
        index === 0 ? (
          <div key={index} className={styles["title-video"]}>
            <h2>
              {title.icon}
              <span style={{ marginLeft: 7 }}>{title.title}</span>
              {title.icon2}
            </h2>
          </div>
        ) : (
          <div key={index} className={classNames(styles["title-youtube"], "justify-content-end")}>
            <a href={title.src} target="_blank" rel="noreferrer" title={title.title}>
              <span className={classNames(styles["icon-title-youtube"], "d-md-block d-none")}>{title.icon}</span>
              <span style={{ marginLeft: 4, marginRight: 4 }}>{title.title}</span>
              {title.icon2}
            </a>
          </div>
        )
      )}
    </div>
  );
}

export function AdSendBanner() {
  return (
    <a
      href={"https://www.sapo.vn"}
      title="Nền tảng quản lý bán hàng đa kênh được sử dụng nhiều nhất Việt Nam"
      target="_blank"
      rel="noreferrer"
      className="image-container"
    >
      <Image src="https://blog.dktcdn.net/files/nen-tang-quan-ly-ban-hang-da-kenh-duoc-su-dung-nhieu-nhat-viet-nam.jpg" alt="Nền tảng quản lý bán hàng đa kênh được sử dụng nhiều nhất Việt Nam" layout="fill" className="image" />
    </a>
  );
}

interface AdImgProps {
  src: string;
  href?: string;
  alt?: string;
}

export function AdImg(props: AdImgProps) {
  const { src, href, alt } = props;
  return (
    <a href={href} className="image-container">
      <Image src={src} alt={alt} layout="fill" quality={100} className="image" />
    </a>
  );
}
